import React, { useEffect, useState } from "react";
import { Button, Form, Col, Row, Modal } from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../_metronic/_partials/controls";

import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  resetData,
  selectData,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  fetchData,
  fetchGenerate,
  fetchExport,
} from "./settingJourneySlice";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import {
  CallApiExport,
  akhirBulan,
  awalBulan,
  createChangeHandler,
  formatTanggal,
  getValueStatus,
  paramsMasterAll,
  setOptionsMaster,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import { SettingJourneyTable } from "./SettingJourneyTable";
import { fetchUser, selectDataUser } from "../user/userSlice";
import Select from "react-select";
import dayjs from "dayjs";

export const SettingJourneyPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const data = useSelector(selectData);
  const loading = useSelector(selectLoading);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const dataUser = useSelector(selectDataUser);

  // Filter
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [show, setShow] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [sales, setSales] = useState("");
  const [optionsSales, setOptionSales] = useState([]);

  useEffect(() => {
    // Reset on first load
    dispatch(resetData());
    // setStartDate(formatTanggal(awalBulan));
    // setEndDate(formatTanggal(akhirBulan));
  }, [dispatch]);


  useEffect(() => {
    async function fetchMyAPI() {
      await dispatch(fetchData({ pageNo: 1, pageSize: 10 }));
      await dispatch(
        fetchUser({
          ...paramsMasterAll,
          roles_in: "COMPANY_SALES,COMPANY_SUPERVISOR",
          is_active: true,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataUser.length > 0) {
      setOptionsMaster(dataUser, setOptionSales, "user_id", "name_username");
    }
  }, [dataUser]);

  const paramsFilter = {
    company_sales_code: code,
    company_sales_name: name,
  };

  const handleSearch = async () => {
    const params = {
      ...paramsFilter,
      pageNo: 1,
      pageSize: 10,
    };

    try {
      const response = await dispatch(fetchData(params));
      if (response.payload.data.status_code === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      const params = {
        ...paramsFilter,
        pageNo: page,
        pageSize: sizePerPage,
      };
      try {
        const response = await dispatch(fetchData(params));
        if (response.payload.data.status_code === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      const response = await dispatch(
        fetchData({
          ...paramsFilter,
          sort_order: sortOrder,
          sort_field: sortField,
          pageNo: 1,
          pageSize: sizePerPage,
        })
      );
      let result;
      if (sortOrder === "asc") {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
        console.log(result, "desc");
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearch();
    }
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const handleGenerate = async () => {
    if (!startDate || !endDate) return showDialog("Please input Date");
    if (!sales) return showDialog("Please input Sales");

    const today = dayjs().startOf("day"); // Hari ini tanpa jam
    const start = dayjs(startDate).startOf("day"); // Tanggal awal tanpa jam
    const end = dayjs(endDate).startOf("day"); // Tanggal akhir tanpa jam
    const diffDays = end.diff(start, "day"); // Hitung selisih hari

    if (start.isBefore(today) || end.isBefore(today)) {
      return showErrorDialog("The date cannot be in the past");
    }

    if (diffDays > 3) {
      return showErrorDialog("The maximum date range is 3 days");
    }

    const params = { date_from: startDate, date_to: endDate, user_id: sales };

    try {
      const response = await dispatch(fetchGenerate(params));
      if (response.payload.data.status_code === 200) {
        await showSuccessDialog(response.payload.message);
        await handleClose();
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleChangeSales = createChangeHandler(setSales);

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <Card>
        <CardHeader title="Journey Setting">
          <CardHeaderToolbar>
            <Button
              className="btn btn-outline-danger mr-4"
              onClick={() =>
                CallApiExport(
                  paramsFilter,
                  fetchExport,
                  dispatch,
                  "JourneySetting"
                )
              }
            >
              Export
            </Button>
            <Button className="btn btn-danger" onClick={() => handleShow()}>
              Generate
            </Button>
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          {/* Filter */}
          <Form className="mb-5">
            <Form.Group as={Row}>
              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Code</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
              </Col>

              {/* Right Row */}

              <Col sm={6}>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    <b>Sales Name</b>
                  </Form.Label>
                  <Col sm={6}>
                    <Form.Control
                      type="text"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      onKeyPress={handleKeyPress}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Col sm={3}>
                    <Button
                      className="btn btn-outline-danger"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                  </Col>
                  {/* <Col sm={3}>
                  <Button
                    className="btn btn-warning"
                    onClick={() => history.push("/masterdata/vendor-create")}
                  >
                    Create
                  </Button>
                </Col> */}
                </Form.Group>
              </Col>
            </Form.Group>
          </Form>

          {/* Table */}

          <SettingJourneyTable
            data={Array.isArray(data) ? data : []}
            page={pageNo}
            sizePerPage={pageSize}
            totalSize={totalRecord}
            onTableChange={handleTableChange}
            loading={loading}
          />
        </CardBody>
      </Card>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        dialogClassName="modal-70"
      >
        <Modal.Header closeButton>
          <Modal.Title>Generate Journey</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              <b>Generate Date</b>
            </Form.Label>

            <Col sm={4}>
              <Form.Control
                type="date"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Form.Label column sm={1} className="mx-md-n4">
              <label>To</label>
            </Form.Label>
            <Col sm={4}>
              <Form.Control
                type="date"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group as={Row}>
            <Form.Label column sm={2}>
              <b>Sales </b>
            </Form.Label>
            <Col sm={4}>
              <Select
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
                options={optionsSales}
                value={getValueStatus(sales, optionsSales)}
                placeholder="Select ..."
                onChange={handleChangeSales}
                isClearable={true}
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            className="mr-4"
            onClick={() => handleClose()}
          >
            Close
          </Button>
          <Button variant="danger" onClick={() => handleGenerate()}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
